/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EnrollmentDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function EnrollmentDate({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/EnrollmentDate",
  onChange
  
}) {
let assignDetailsOnlyCoverageValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'onlyCoverage',
})
let txCategoryInsuredInsuredInsuranceSubscriptionEnrollmentDateValueData = fromData.useDataFormat({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.enrollment_date',
format: fromFormat.dateISOIn,
})
let txCategoryInsuredInsuredInsuranceSubscriptionEnrollmentDateChangeData = fromData.useDataChange({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.enrollment_date',
formatOut: fromHelpers.formatOutDate,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 type="text"
 data="assign_details.onlyCoverage"
 disabled={assignDetailsOnlyCoverageValueData}
 data="tx_category_insured.insured.insurance_subscription.enrollment_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 value={txCategoryInsuredInsuredInsuranceSubscriptionEnrollmentDateValueData}
 onChange={txCategoryInsuredInsuredInsuranceSubscriptionEnrollmentDateChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Effective Date"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}